import React from "react";
import HeadingText from "./HeadingText";
import { env } from "../config";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import Iconmap from "./Iconmap";

function CloudStackDevelopmentPageIntro(props: any) {
    const { ProductDevelopmentPageIntro, imagePosition, altText } = props;
    const { ref, inView } = useInView({
        // triggerOnce: true,
        threshold: 0,
    });
    let navigate = useNavigate();

    const buttonLink = ProductDevelopmentPageIntro?.ButtonText?.includes("#")
        ? ProductDevelopmentPageIntro?.ButtonText?.split("#")
        : null;

    return (
        <div className="bg-[#212121]">
            <div className="px-5 py-7 bg-[#12121] relative lg:px-10 text-white xl:px-20 lg:py-14  max-w-screen-2xl lg:mx-auto text-black-75 flex-col-reverse flex lg:flex-row lg:justify-between">
                <svg
                    className=" hidden lg:block scale-75 lg:absolute top-[5%] rotate-12 left-[50%] opacity-0 lg:opacity-100"
                    width="380"
                    height="375"
                    viewBox="0 0 380 375"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                        stroke="#5F5F5F"
                        strokeOpacity="0.2"
                        strokeWidth="4"
                    />
                </svg>

                <svg
                    className="z-10 hidden lg:block scale-75 lg:absolute -bottom-20 right-[5%] opacity-0 lg:opacity-100"
                    width="380"
                    height="375"
                    viewBox="0 0 380 375"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                        stroke="#5F5F5F"
                        strokeOpacity="0.2"
                        strokeWidth="4"
                    />
                </svg>
                <div ref={ref} className="lg:w-1/2 flex flex-col justify-center">

                    <div className="rounded-full py-1.5 px-4 bg-[#404041] w-max mb-3 text-sm text-[#F7941E]">
                        Netstratum Cloudstack
                    </div>
                    <div
                        className={` text-2xl md:text-4xl lg:text-5xl   font-custom font-bold`}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: ProductDevelopmentPageIntro?.Title1,
                            }}
                        />
                        {/* {ProductDevelopmentPageIntro?.Title1} */}
                    </div>
                    <div
                        className={`text-2xl md:text-4xl lg:text-5xl md:mt-3  font-custom font-bold`}
                    >
                        {inView ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: ProductDevelopmentPageIntro?.Title2,
                                }}
                            />
                        ) : (
                            <div
                                className={` text-2xl md:text-4xl lg:text-5xl  font-custom font-bold`}
                            >
                                Development
                            </div>
                        )}
                    </div>

                    <div className={`lg:text-lg md:text-base  font-normal mt-3 pt-3`}>
                        {ProductDevelopmentPageIntro?.Description1}
                    </div>
                    <div className={`lg:text-lg md:text-base   font-normal pt-3`}>
                        {ProductDevelopmentPageIntro?.Description2}
                    </div>

                    {buttonLink ? (
                        <button
                            onClick={() => {
                                buttonLink[1]?.includes("https")
                                    ? window.open(buttonLink[1], "_blank", "noopener,noreferrer")
                                    : navigate(buttonLink);
                            }}
                            className=" bg-[#616161] text-white   border border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {buttonLink[0]}
                        </button>
                    ) : ProductDevelopmentPageIntro?.ButtonText ? (
                        <button
                            onClick={() => {
                                navigate("/contact-us");
                            }}
                            className=" bg-[#F7941E] text-white border border-[#616161] hover:bg-white hover:text-[#F7941E] duration-300 hover:border hover:border-[#F7941E] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {ProductDevelopmentPageIntro?.ButtonText}
                        </button>
                    ) : null}
                </div>
                <img
                    alt={altText}
                    loading="lazy"
                    className={`${imagePosition} z-[100]`}
                    src={`${env}${ProductDevelopmentPageIntro?.Image?.data?.attributes?.url}`}
                />{" "}
            </div>
            <div className="px-5 py-7 lg:px-10 xl:px-20 lg:py-14 grid  max-w-screen-2xl lg:mx-auto md:grid-cols-2 lg:grid-cols-4 gap-3 ">
                {ProductDevelopmentPageIntro?.introCards?.map((node: any, index: number) => {
                    return (
                        <div
                            key={index + node?.Title}
                            data-aos="fade-left"
                            data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                            className={` rounded-[10px] bg-white p-6  flex flex-col  md:text-left md:items-start justify-evenly`}
                        >
                            {node?.Image?.data ? (
                                <img
                                    className="w-12 h-12"
                                    src={`${env}${node?.Image?.data?.attributes?.url}`}
                                    alt="not available"
                                />
                            ) : (
                                <Iconmap type={node?.IconType} />
                            )}

                            <div className="font-bold font-custom  md:text-base text-base  pt-1 pb-1">
                                {node?.Title}
                            </div>
                            <div className="font-custom md:text-base text-base ">
                                {node?.Description}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>

    );
}

export default CloudStackDevelopmentPageIntro;
